import {api} from "../../../../api/API";
import {LiteKitPopup} from "../../settings/LiteKitPopup";
import React, {useContext} from "react";
import {DoorElevation} from "../../../../api/Openings";
import { EditContext } from "../../../../misc/scroller/EditProvider";
import {DropDownContext} from "../../settings/DropDowns";

export function LiteKitCreate(props: {
    value: DoorElevation;
    createName: string;
    onClose(): void;
}) {
    const edit = useContext(EditContext);
    const ddlCtx = useContext(DropDownContext);

    return (
        <LiteKitPopup
            entityName={props.createName}
            name={props.createName}
            showCreateGlobalOpt
            onDone={async (v) => {
                if(v.createGlobal) {
                    await api.ddlOptions.upsertDefaultLiteKitProfile({
                        name: props.createName,
                        file: v.file,
                    });

                    ddlCtx.reload();

                    await edit.update(Object.assign({}, props.value, {
                        updatedAt: new Date().toISOString(),
                        doorElevationProfileDefaultName: props.createName,
                    }))
                } else {
                    await edit.update(Object.assign({}, props.value, {
                        updatedAt: new Date().toISOString(),
                        doorElevationProfileCustomFile: v.file,
                    }))
                }

                edit.reload();
                props.onClose();
            }}
            onCancel={props.onClose}
        />
    )
}